import React from 'react';
import { styled } from 'linaria/react'
import { theme } from '../../Theme';
import { NavArrowLeft } from 'iconoir-react';
import CategoryFallback from '../../../svg/fallback-category.webp'
import { Above, Below } from '@jetshop/ui/Breakpoints';

const BannerSkeletonContainer = styled.div`
   & {
      background: #E9E9E9;
   }

   .width-1{
      width: 200px;
   }
   
   .width-2{
      width: 100px;
   }

   .button-tag {
      border-radius: 50px;
      font-family: var(--font-industry);
      font-weight: 700;
      color: #fff;
      margin-right: 0.5rem;
      margin-bottom: 0.5rem;
      white-space: nowrap;
   }

   .page-hero-second{
      position: relative;
      border-radius: 2rem 0 0 0;
      overflow: hidden;
      ${theme.below.xl}{
         border-radius: 0;
      }
   }

   .page-hero-second h2 {
      ${theme.below.xl}{
         margin-bottom: 3.5rem !important;
      }
   }

   .category-tags-container-mobile {
      ${theme.below.xl}{
         margin-bottom: 2.75rem !important;
      }
   }

   .page-hero-second img {
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
      height: 100%;
      width: 100%;
      object-fit: cover;
  }

   .button-tag-wrapper .button-tag:last-child {
      margin-right: 0;
   }
   
   .button-tag--active {
      background-color: rgb(var(--color-vb-gray-3));
      transition: background-color 0.5s ease;
   }
   
   .button-tag--active:hover {
      background-color: rgba(var(--color-vb-gray-3), 0.75);
      transition: background-color 0.5s ease;
   }
   
   .button-tag--default {
      background-color: var(--color-vb-blue);
      transition: background-color 0.5s ease;
   }
   
   .button-tag--default:hover {
      background-color: var(--color-vb-blue-darker);
      transition: background-color 0.5s ease;
   }

   .button-tag--icon {
      width: fit-content;
      background-color: rgb(var(--color-vb-gray-3));
      transition: background-color 0.5s ease;
  }
`

const BannerSkeletonOld = () => {
   return ( 
      <BannerSkeletonContainer>
        <div className="row p-0 m-0">
          <div className="page-hero-first col-12 col-xl-6 pt-64 pb-32 pr-32 pl-128 flex-column justify-content-between d-none d-xl-flex">
            <div className="page-hero-first-top d-flex flex-column">
              <ul className="breadcrumb d-none d-xl-block">
                <li><a className="link--black link--vb" href="/#"><div className="placeholder placeholder-wave width-1"></div></a></li>
                <li><a className="link--black link--vb" href="/#"><div className="placeholder placeholder-wave width-2"></div></a></li>
                <li><a className="link--black link--vb" href="/#"><div className="placeholder placeholder-wave w-25"></div></a></li>
              </ul>
              <h2 className="page-hero-title d-none d-xl-block"><span className="placeholder placeholder-wave w-50 "></span></h2>
            </div>
            <div className="page-hero-first-bottom d-flex flex-column">
              <button className="button-tag button-tag--icon py-8 pr-32 pl-16 m-0">
                <NavArrowLeft color="white"></NavArrowLeft> <span className="placeholder placeholder-wave width-1"></span>
              </button>
              <p className="page-hero-category-title py-16 m-0"><div className="placeholder placeholder-wave w-25"></div></p>
              <div className="button-tag-wrapper">
                <button className="button-tag button-tag--active py-8 px-32"><span className="placeholder placeholder-wave width-1"></span></button>
                <button className="button-tag button-tag--default py-8 px-32"><span className="placeholder placeholder-wave width-2"></span></button>
                <button className="button-tag button-tag--default py-8 px-32"><span className="placeholder placeholder-wave width-1"></span></button>
                <button className="button-tag button-tag--default py-8 px-32"><span className="placeholder placeholder-wave width-1"></span></button>
                <button className="button-tag button-tag--default py-8 px-32"><span className="placeholder placeholder-wave width-2"></span></button>
                <button className="button-tag button-tag--default py-8 px-32"><span className="placeholder placeholder-wave width-1"></span></button>
                <button className="button-tag button-tag--default py-8 px-32"><span className="placeholder placeholder-wave width-1"></span></button>
                <button className="button-tag button-tag--default py-8 px-32"><span className="placeholder placeholder-wave width-2"></span></button>
                <button className="button-tag button-tag--default py-8 px-32"><span className="placeholder placeholder-wave width-1"></span></button>
                <button className="button-tag button-tag--default py-8 px-32"><span className="placeholder placeholder-wave width-1"></span></button>
              </div>
            </div>
          </div>
          <div className="page-hero-second col-12 col-xl-6 p-0">
            <div className="page-hero-image">
                <ul className="breadcrumb d-block d-xl-none position-relative z-2 p-128 pb-64 m-0">
                    <li className='mt-16'><a className="link--black link--vb" href="/#"><div className="placeholder placeholder-wave w-25"></div></a></li>
                  </ul>
                <h2 className="page-hero-title d-block d-xl-none position-relative z-2 px-128 m-0"><div className="placeholder w-50"></div></h2>
                <img className="img-fluid placeholder placeholder-wave" alt="Default" src={CategoryFallback} />
          </div>
        </div>
        <div className='d-block d-xl-none category-tags-container-mobile px-128 mt-16'>
         <h2 className="page-hero-title d-block d-xl-none position-relative z-2"><div className="placeholder w-50"></div></h2>
         <div className="d-flex mt-64">
            <button className="button-tag button-tag--active py-8 px-32"><span className="placeholder placeholder-wave width-1"></span></button>
            <button className="button-tag button-tag--default py-8 px-32"><span className="placeholder placeholder-wave width-2"></span></button>
         </div>
        </div>
      </div>
      </BannerSkeletonContainer>
   )
}

export default BannerSkeletonOld
